export default __webpack_public_path__ + "static/media/huawei.4694bf92.svg";